export { default } from "./ComparePlayersChartContainer";
